
<v-app>
  <v-fab-transition>
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
      title="Back To Top"
      class="back-to-top-button">
      <v-icon small>fas fa-chevron-up fa-2x</v-icon>
    </v-btn>
  </v-fab-transition>
  <navigation></navigation>
  <cookie-banner></cookie-banner>
  <v-main class="main-wrapper">
    <router-view></router-view>
  </v-main>
  <Footer></Footer>
</v-app>
